<script setup>
defineProps({
  dismissLabel: { type: String, required: true },
  testId: { type: String, default: '' },
});

const emit = defineEmits(['dismiss']);
const alertGlyph = '!';
</script>

<template>
  <div
    class="flex items-center gap-2 rounded-[10px] border border-[#FFF0CD] bg-[#FFFAF0] py-[6px] pr-3 pl-4 font-roboto text-sm leading-5 text-[#464F53]"
    role="alert"
    :data-test="testId || undefined"
  >
    <span
      class="mr-1 grid size-5 shrink-0 place-items-center rounded-full bg-[#FFC43E] text-xs font-bold leading-none text-white"
      aria-hidden="true"
    >
      {{ alertGlyph }}
    </span>
    <p class="m-0 mr-7 flex-1 py-2 text-sm leading-5"><slot /></p>
    <button
      type="button"
      class="-mt-1 -mr-2 ml-4 shrink-0 p-1 text-[#FFC43E] hover:text-[#D99A00]"
      :aria-label="dismissLabel"
      :data-test="testId ? `${testId}-close` : undefined"
      @click="emit('dismiss')"
    >
      <span class="i-lucide-x size-4" />
    </button>
  </div>
</template>
